import { OnInit, Input, Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FiltreService } from '../../filtre.service';
import { environment } from 'src/environments/environment';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  template: 'Pas de template dans cette classe …',
  styleUrls: ['./input.component.css']
})
export class InputComponent implements OnInit, OnDestroy {
  @Input()
  label = '';
  /**
   * Permet de personnaliser le label du libellé à charger
   */
  @Input()
  labelLibelle;
  /** Permet de personnaliser le libellé afficher. Pour que celui-ci n’apparaisse pas, il faut renseigner « vide » */
  @Input()
  libelle = '';
  @Input()
  erreursCroisees: string[];
  /**
   * Le formulaire contenant le control en cours.
   *! Ce n’est pas forcément la racine du formulaire.
   */
  @Input()
  rootForm: UntypedFormGroup;
  /**
   * Permet d’ajouter un signe à droite d’un input (par exemple €).
   * Pas implémenté dans tous les components.
   */
  @Input()
  prefixe: string;
  /**
   * Permet d’ajouter une chaîne de caractère avant l’identifiant HTML
   */
  @Input()
  preId: string;
  /**
   * Permet de mettre le champ en lecture seul
   */
  @Input()
    enLectureSeule = false;
    /**
     * Contrôle le passage en lecture seul du composant
     */
    afficherEnLectureSeule = false;
  /**
   * Permet d'afficher une infobulle instantanée
   */
  @Input()
    infoBulle: string = '';
  /**
   * Permet de donner la position d'une infobulle instantanée, par defaut à droite
   */
   @Input()
   positionIB: string = 'right';

   /**
   * id figurant dans la partie HTML
   * preId + '_' + label
   */
    idHtml: string;
  libelle$: BehaviorSubject<string>;

  /**
   * Contient la liste des subscriptions effectuées à fermer à la destruction
   */
  protected subTab: Subscription[] = [];

  /**
   * Fonction permettant de faire les traitements nécessaires pour gérer les sous questions dépendantes
   * de cette question.
   */
  private gestionQuestionsFils(valeur: string) {
    if (!this.currentControl.disabled) {
      this.filtreService.mapFiltre.get(this.label).forEach(element => {
        if (element.condition(valeur)) {
          element.varFils.forEach((nomVariable) => {
            // Si le nom de variable n’existe pas dans le rootForm, message d’erreur
            if (!this.rootForm.get(nomVariable)) {
              console.error(`Impossible de trouver ${nomVariable}  dans le FormGroup ci-joint (fils de la variable ${this.label}).`
                , this.rootForm);
            } else {
              // On affiche le champ
              this.activerControle(nomVariable);
            }
          });
        } else {
          element.varFils.forEach((nomVariable) => {
            if (!this.rootForm.get(nomVariable)) {
              console.error(`Impossible de trouver ${nomVariable}  dans le FormGroup ci-joint (fils de la variable ${this.label}).`
                , this.rootForm);
            } else {
              // On cache le champ
              this.desactiverControle(nomVariable);
            }
          });
        }
      });
    } else {
      // Si le formcontrol est désactivé, on désactive tous les sous formControls
      this.filtreService.mapFiltre.get(this.label).forEach(element => {
        element.varFils.forEach((nomVariable) => {
          this.desactiverControle(nomVariable);
        });
      });
    }
  }
  /**
   * Fonction pour désactiver des champs du questionnaire
   * @param nomVariable label de la question à désactiver
   */
  private desactiverControle(nomVariable: string): void {
    if (this.rootForm.get(nomVariable)) {
      if (this.rootForm.get(nomVariable).enabled) {
        this.rootForm.get(nomVariable).disable();
      }
    } else {
      console.error(nomVariable + ' n’existe pas dans le formulaire');
    }
    // Vérification s’il y a des sous contrôles à désactiver
    if (this.filtreService.mapFiltre.has(nomVariable)) {
      this.filtreService.mapFiltre.get(nomVariable).forEach((element) => {
        element.varFils.forEach((nomVarFils) => {
          this.desactiverControle(nomVarFils);
        });
      });
    }
  }
  /**
  * Fonction pour désactiver des champs du questionnaire
  * @param nomVariable label de la question à désactiver
  */
  private activerControle(nomVariable: string): void {
    if (this.rootForm.get(nomVariable).disabled) {
      this.rootForm.get(nomVariable).enable();
    }
  }

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
  ) { }

  ngOnDestroy(): void {
    this.subTab.forEach((subscription: Subscription) => {
      if (!subscription.closed) { subscription.unsubscribe(); }
    });
  }

  ngOnInit() {
    // Récupération de l’objet contenant le libellé
    if (this.libelle) {
      if (this.libelle === 'vide') {
        this.libelle$ = new BehaviorSubject('');
      } else {
        // si le libellé est fourni dans le template
        this.libelle$ = new BehaviorSubject(this.libelle);
      }
    } else {
      // sinon on demande au service gérant les libellés
      if (this.labelLibelle) {
        this.libelle$ = this.libelleService.getLibelle$(this.labelLibelle);
      } else {
        this.libelle$ = this.libelleService.getLibelle$(this.label);
      }
    }
    // Si en consultation, lecture seule à vrai
    this.afficherEnLectureSeule = this.enLectureSeule;
    this.modeRenduService.enModeConsultation$.subscribe((value) => {
      if (value) {
        this.afficherEnLectureSeule = true;
      } else {
        this.afficherEnLectureSeule = this.enLectureSeule;
      }
    });
    // Récupération du questionnaire
    if (!this.rootForm) {
      this.rootForm = this.formulaireService.getRootForm();
    }
    if (!this.preId) {
      this.idHtml = this.label;
    } else {
      this.idHtml = this.preId + '_' + this.label;
    }
    // Gestion des questions fils via des filtres si elles existent :
    if (this.filtreService.mapFiltre.get(this.label)) {
      this.subTab.push(
        this.currentControl.valueChanges.subscribe((nouvelleValeur) => {
          this.gestionQuestionsFils(nouvelleValeur);
        })
      );
      // Pour bug lors de l’activation d’un contrôle père qui active tout sans prêter attention aux filtres :'(
      this.subTab.push(
        this.currentControl.statusChanges.pipe().subscribe((status) => {
          if (environment.recette && status !== 'DISABLED') {
            // console.log('[Test]', 'Changement du status du composant ' + this.label + '. Actualisation des filtres dans 25 ms.');
          }
          setTimeout(() => { this.gestionQuestionsFils(this.currentControl.value); }, 25);
        })
      );
      this.gestionQuestionsFils(this.currentControl.value);
    }

  }
  champInvalide() {
    return this.currentControl.invalid;
  }
  champValide() {
    // Le champ est valide s’il n’y a pas d’erreur croisée
    return this.currentControl.valid && !this.aErreurCroiseeActive();
  }
  champTouche() {
    return this.currentControl.touched;
  }
  
  champNonObligatoire() {
    return !(this.champValide()) && !(this.champInvalide()) && !this.aErreurCroiseeActive();
  }

  aErreurCroiseeActive(): boolean {
    let reponse = false;
    if (this.erreursCroisees) {
      this.erreursCroisees.forEach(erreur => reponse = reponse || this.rootForm.getError(erreur));
    }
    return reponse;
  }
  protected erreursAffichable(): boolean {
    return this.currentControl.errors && this.champTouche();
  }
  get currentControl(): UntypedFormControl {
    if (! this.rootForm.get(this.label)) {
      console.error(`Le formControl ${this.label} n’existe pas dans le FormGroup suivant :`, this.rootForm );
      this.rootForm.setControl(this.label, new UntypedFormControl(''));
    }
    return this.rootForm.get(this.label) as UntypedFormControl;
  }
}
